// src/services/luxLibrisAssets.js
// Lux Libris visual asset lookup for Hermod's Path

const LUX_LIBRIS_BASE_URL = 'https://luxlibris.org';

// ── Saint Card Lookup (251 images) ──

const SAINT_LOOKUP = {
  'adalbert': { name: 'St. Adalbert', file: 'saint_adalbert.png' },
  'aelred': { name: 'St. Aelred', file: 'saint_aelred.png' },
  'agapitus': { name: 'St. Agapitus', file: 'saint_agapitus.png' },
  'agatha': { name: 'St. Agatha', file: 'saint_agatha.png' },
  'agnes': { name: 'St. Agnes', file: 'saint_agnes.png' },
  'aidan': { name: 'St. Aidan', file: 'saint_aidan.png' },
  'alban': { name: 'St. Alban', file: 'saint_alban.png' },
  'albert the great': { name: 'St. Albert the Great', file: 'saint_albertgreat.png' },
  'albertgreat': { name: 'St. Albert the Great', file: 'saint_albertgreat.png' },
  'alexius': { name: 'St. Alexius', file: 'saint_alexius.png' },
  'aloysius': { name: 'St. Aloysius Gonzaga', file: 'saint_aloysius.png' },
  'alphonsus': { name: 'St. Alphonsus Liguori', file: 'saint_alphonsus.png' },
  'ambrose': { name: 'St. Ambrose', file: 'saint_ambrose.png' },
  'anastasia': { name: 'St. Anastasia', file: 'saint_anastasia.png' },
  'andre': { name: 'St. Andre Bessette', file: 'saint_andre.png' },
  'andre bessette': { name: 'St. Andre Bessette', file: 'saint_andre.png' },
  'andrew': { name: 'St. Andrew', file: 'saint_andrew.png' },
  'angela': { name: 'St. Angela Merici', file: 'saint_angela.png' },
  'angela merici': { name: 'St. Angela Merici', file: 'saint_angela.png' },
  'anne': { name: 'St. Anne', file: 'saint_anne.png' },
  'anselm': { name: 'St. Anselm', file: 'saint_anselm.png' },
  'ansgar': { name: 'St. Ansgar', file: 'saint_ansgar.png' },
  'anthony': { name: 'St. Anthony of Padua', file: 'saint_anthony.png' },
  'anthony of padua': { name: 'St. Anthony of Padua', file: 'saint_anthony.png' },
  'anthony the great': { name: 'St. Anthony the Great', file: 'saint_anthonygreat.png' },
  'anthonygreat': { name: 'St. Anthony the Great', file: 'saint_anthonygreat.png' },
  'antioch': { name: 'St. Ignatius of Antioch', file: 'saint_antioch.png' },
  'ignatius of antioch': { name: 'St. Ignatius of Antioch', file: 'saint_antioch.png' },
  'antonius': { name: 'St. Antonius', file: 'saint_antonius.png' },
  'apollinaris': { name: 'St. Apollinaris', file: 'saint_apollinaris.png' },
  'apollonia': { name: 'St. Apollonia', file: 'saint_apollonia.png' },
  'aquinas': { name: 'St. Thomas Aquinas', file: 'saint_aquinas.png' },
  'thomas aquinas': { name: 'St. Thomas Aquinas', file: 'saint_aquinas.png' },
  'athanasius': { name: 'St. Athanasius', file: 'saint_athanasius.png' },
  'augustine': { name: 'St. Augustine', file: 'saint_augustine.png' },
  'bakhita': { name: 'St. Josephine Bakhita', file: 'saint_bakhita.png' },
  'josephine bakhita': { name: 'St. Josephine Bakhita', file: 'saint_bakhita.png' },
  'baptist': { name: 'St. John the Baptist', file: 'saint_baptist.png' },
  'john the baptist': { name: 'St. John the Baptist', file: 'saint_baptist.png' },
  'barbara': { name: 'St. Barbara', file: 'saint_barbara.png' },
  'barbara yi': { name: 'St. Barbara Yi', file: 'saint_barbarayi.png' },
  'barbarayi': { name: 'St. Barbara Yi', file: 'saint_barbarayi.png' },
  'barnabas': { name: 'St. Barnabas', file: 'saint_barnabas.png' },
  'bartholomew': { name: 'St. Bartholomew', file: 'saint_bartholomew.png' },
  'bede': { name: 'St. Bede the Venerable', file: 'saint_bede.png' },
  'benedict': { name: 'St. Benedict', file: 'saint_benedict.png' },
  'berchmans': { name: 'St. John Berchmans', file: 'saint_berchmans.png' },
  'john berchmans': { name: 'St. John Berchmans', file: 'saint_berchmans.png' },
  'bernadette': { name: 'St. Bernadette', file: 'saint_bernadette.png' },
  'blaise': { name: 'St. Blaise', file: 'saint_blaise.png' },
  'bonaventure': { name: 'St. Bonaventure', file: 'saint_bonaventure.png' },
  'boniface': { name: 'St. Boniface', file: 'saint_boniface.png' },
  'bosco': { name: 'St. John Bosco', file: 'saint_bosco.png' },
  'john bosco': { name: 'St. John Bosco', file: 'saint_bosco.png' },
  'don bosco': { name: 'St. John Bosco', file: 'saint_bosco.png' },
  'brigid': { name: 'St. Brigid of Ireland', file: 'saint_brigid.png' },
  'brigid of ireland': { name: 'St. Brigid of Ireland', file: 'saint_brigid.png' },
  'brigid of sweden': { name: 'St. Brigid of Sweden', file: 'saint_brigidsweden.png' },
  'brigidsweden': { name: 'St. Brigid of Sweden', file: 'saint_brigidsweden.png' },
  'bruno': { name: 'St. Bruno', file: 'saint_bruno.png' },
  'cabrini': { name: 'St. Frances Xavier Cabrini', file: 'saint_cabrini.png' },
  'frances cabrini': { name: 'St. Frances Xavier Cabrini', file: 'saint_cabrini.png' },
  'camillus': { name: 'St. Camillus de Lellis', file: 'saint_camillus.png' },
  'canute': { name: 'St. Canute', file: 'saint_canute.png' },
  'carlo': { name: 'Bl. Carlo Acutis', file: 'saint_carlo.png' },
  'carlo acutis': { name: 'Bl. Carlo Acutis', file: 'saint_carlo.png' },
  'casimir': { name: 'St. Casimir', file: 'saint_casimir.png' },
  'catherine': { name: 'St. Catherine of Siena', file: 'saint_catherine.png' },
  'catherine of siena': { name: 'St. Catherine of Siena', file: 'saint_catherine.png' },
  'cecilia': { name: 'St. Cecilia', file: 'saint_cecilia.png' },
  'chanel': { name: 'St. Peter Chanel', file: 'saint_chanel.png' },
  'peter chanel': { name: 'St. Peter Chanel', file: 'saint_chanel.png' },
  'charles': { name: 'St. Charles Borromeo', file: 'saint_charles.png' },
  'charles borromeo': { name: 'St. Charles Borromeo', file: 'saint_charles.png' },
  'christopher': { name: 'St. Christopher', file: 'saint_christopher.png' },
  'clare': { name: 'St. Clare of Assisi', file: 'saint_clare.png' },
  'clare of assisi': { name: 'St. Clare of Assisi', file: 'saint_clare.png' },
  'claver': { name: 'St. Peter Claver', file: 'saint_claver.png' },
  'peter claver': { name: 'St. Peter Claver', file: 'saint_claver.png' },
  'clement': { name: 'St. Clement', file: 'saint_clement.png' },
  'climacus': { name: 'St. John Climacus', file: 'saint_climacus.png' },
  'john climacus': { name: 'St. John Climacus', file: 'saint_climacus.png' },
  'clitherow': { name: 'St. Margaret Clitherow', file: 'saint_clitherow.png' },
  'margaret clitherow': { name: 'St. Margaret Clitherow', file: 'saint_clitherow.png' },
  'columba': { name: 'St. Columba', file: 'saint_columba.png' },
  'cornelius': { name: 'St. Cornelius', file: 'saint_cornelius.png' },
  'cosmas': { name: 'Sts. Cosmas and Damian', file: 'saint_cosmas.png' },
  'cosmas and damian': { name: 'Sts. Cosmas and Damian', file: 'saint_cosmas.png' },
  'cuthbert': { name: 'St. Cuthbert', file: 'saint_cuthbert.png' },
  'cyril': { name: 'St. Cyril', file: 'saint_cyril.png' },
  'damian of molokai': { name: 'St. Damian of Molokai', file: 'saint_damianmolokai.png' },
  'damianmolokai': { name: 'St. Damian of Molokai', file: 'saint_damianmolokai.png' },
  'damian': { name: 'St. Damian the Physician', file: 'saint_damianphysician.png' },
  'damianphysician': { name: 'St. Damian the Physician', file: 'saint_damianphysician.png' },
  'david': { name: 'St. David', file: 'saint_david.png' },
  'demetrius': { name: 'St. Demetrius', file: 'saint_demetrius.jpg' },
  'denis': { name: 'St. Denis', file: 'saint_denis.png' },
  'dismas': { name: 'St. Dismas', file: 'saint_dismas.png' },
  'dominic': { name: 'St. Dominic', file: 'saint_dominic.png' },
  'dominic savio': { name: 'St. Dominic Savio', file: 'saint_dominicsavio.png' },
  'dominicsavio': { name: 'St. Dominic Savio', file: 'saint_dominicsavio.png' },
  'dorothy': { name: 'St. Dorothy', file: 'saint_dorothy.png' },
  'drexel': { name: 'St. Katharine Drexel', file: 'saint_drexel.png' },
  'katharine drexel': { name: 'St. Katharine Drexel', file: 'saint_drexel.png' },
  'duchesne': { name: 'St. Philippine Duchesne', file: 'saint_duchesne.png' },
  'philippine duchesne': { name: 'St. Philippine Duchesne', file: 'saint_duchesne.png' },
  'dunstan': { name: 'St. Dunstan', file: 'saint_dunstan.png' },
  'edith of wilton': { name: 'St. Edith of Wilton', file: 'saint_edithwilton.png' },
  'edithwilton': { name: 'St. Edith of Wilton', file: 'saint_edithwilton.png' },
  'edith': { name: 'St. Edith of Wilton', file: 'saint_edithwilton.png' },
  'edmund': { name: 'St. Edmund', file: 'saint_edmund.png' },
  'edward': { name: 'St. Edward the Confessor', file: 'saint_edward.png' },
  'eligius': { name: 'St. Eligius', file: 'saint_eligius.png' },
  'elizabeth': { name: 'St. Elizabeth of Hungary', file: 'saint_elizabeth.png' },
  'elizabeth of hungary': { name: 'St. Elizabeth of Hungary', file: 'saint_elizabeth.png' },
  'emiliani': { name: 'St. Jerome Emiliani', file: 'saint_emiliani.png' },
  'jerome emiliani': { name: 'St. Jerome Emiliani', file: 'saint_emiliani.png' },
  'enda': { name: 'St. Enda', file: 'saint_enda.png' },
  'ephrem': { name: 'St. Ephrem', file: 'saint_ephrem.png' },
  'erasmus': { name: 'St. Erasmus', file: 'saint_erasmus.png' },
  'eric': { name: 'St. Eric', file: 'saint_eric.png' },
  'eucherius': { name: 'St. Eucherius', file: 'saint_eucherius.png' },
  'euphrasia': { name: 'St. Euphrasia', file: 'saint_euphrasia.png' },
  'eusebius': { name: 'St. Eusebius', file: 'saint_eusebius.png' },
  'evangelist': { name: 'St. John the Evangelist', file: 'saint_evangelist.png' },
  'john the evangelist': { name: 'St. John the Evangelist', file: 'saint_evangelist.png' },
  'evaristus': { name: 'St. Evaristus', file: 'saint_evaristus.png' },
  'fabian': { name: 'St. Fabian', file: 'saint_fabian.png' },
  'faustina': { name: 'St. Faustina', file: 'saint_faustina.png' },
  'felix': { name: 'St. Felix', file: 'saint_felix.png' },
  'ferdinand': { name: 'St. Ferdinand', file: 'saint_ferdinand.png' },
  'ferrer': { name: 'St. Vincent Ferrer', file: 'saint_ferrer.png' },
  'vincent ferrer': { name: 'St. Vincent Ferrer', file: 'saint_ferrer.png' },
  'fiacre': { name: 'St. Fiacre', file: 'saint_fiacre.png' },
  'fidelis': { name: 'St. Fidelis', file: 'saint_fidelis.png' },
  'finnian': { name: 'St. Finnian', file: 'saint_finnian.png' },
  'flavian': { name: 'St. Flavian', file: 'saint_flavian.png' },
  'florian': { name: 'St. Florian', file: 'saint_florian.png' },
  'francis': { name: 'St. Francis of Assisi', file: 'saint_francis.png' },
  'francis of assisi': { name: 'St. Francis of Assisi', file: 'saint_francis.png' },
  'francis de sales': { name: 'St. Francis de Sales', file: 'saint_francisdesales.png' },
  'francisdesales': { name: 'St. Francis de Sales', file: 'saint_francisdesales.png' },
  'francis xavier': { name: 'St. Francis Xavier', file: 'saint_francisxavier.png' },
  'francisxavier': { name: 'St. Francis Xavier', file: 'saint_francisxavier.png' },
  'frassati': { name: 'Bl. Pier Giorgio Frassati', file: 'saint_frassati.png' },
  'pier giorgio frassati': { name: 'Bl. Pier Giorgio Frassati', file: 'saint_frassati.png' },
  'fructuosus': { name: 'St. Fructuosus', file: 'saint_fructuosus.png' },
  'fursey': { name: 'St. Fursey', file: 'saint_fursey.png' },
  'gabriel': { name: 'St. Gabriel the Archangel', file: 'saint_gabriel.png' },
  'gall': { name: 'St. Gall', file: 'saint_gall.png' },
  'gemma': { name: 'St. Gemma Galgani', file: 'saint_gemma.png' },
  'gemma galgani': { name: 'St. Gemma Galgani', file: 'saint_gemma.png' },
  'genesius': { name: 'St. Genesius', file: 'saint_genesius.png' },
  'genevieve': { name: 'St. Genevieve', file: 'saint_genevieve.png' },
  'george': { name: 'St. George', file: 'saint_george.png' },
  'germanus': { name: 'St. Germanus', file: 'saint_germanus.png' },
  'gianna': { name: 'St. Gianna Beretta Molla', file: 'saint_gianna.png' },
  'gianna molla': { name: 'St. Gianna Beretta Molla', file: 'saint_gianna.png' },
  'giles': { name: 'St. Giles', file: 'saint_giles.png' },
  'gordius': { name: 'St. Gordius', file: 'saint_gordius.png' },
  'goretti': { name: 'St. Maria Goretti', file: 'saint_goretti.png' },
  'maria goretti': { name: 'St. Maria Goretti', file: 'saint_goretti.png' },
  'goupil': { name: 'St. Rene Goupil', file: 'saint_goupil.png' },
  'rene goupil': { name: 'St. Rene Goupil', file: 'saint_goupil.png' },
  'gregory the great': { name: 'St. Gregory the Great', file: 'saint_gregorygreat.png' },
  'gregorygreat': { name: 'St. Gregory the Great', file: 'saint_gregorygreat.png' },
  'gregory nazianzen': { name: 'St. Gregory Nazianzen', file: 'saint_gregorynazianzen.png' },
  'gregorynazianzen': { name: 'St. Gregory Nazianzen', file: 'saint_gregorynazianzen.png' },
  'gregory of nyssa': { name: 'St. Gregory of Nyssa', file: 'saint_gregorynyssa.png' },
  'gregorynyssa': { name: 'St. Gregory of Nyssa', file: 'saint_gregorynyssa.png' },
  'hedwig': { name: 'St. Hedwig', file: 'saint_hedwig.png' },
  'helena': { name: 'St. Helena', file: 'saint_helena.png' },
  'hildegard': { name: 'St. Hildegard of Bingen', file: 'saint_hildegard.png' },
  'hildegard of bingen': { name: 'St. Hildegard of Bingen', file: 'saint_hildegard.png' },
  'hippolytus': { name: 'St. Hippolytus', file: 'saint_hippolytus.png' },
  'hubert': { name: 'St. Hubert', file: 'saint_hubert.png' },
  'hungary': { name: 'St. Stephen of Hungary', file: 'saint_hungary.png' },
  'stephen of hungary': { name: 'St. Stephen of Hungary', file: 'saint_hungary.png' },
  'ignatius': { name: 'St. Ignatius of Loyola', file: 'saint_ignatius.png' },
  'ignatius of loyola': { name: 'St. Ignatius of Loyola', file: 'saint_ignatius.png' },
  'isabel': { name: 'St. Isabel of Portugal', file: 'saint_isabel.png' },
  'isidore': { name: 'St. Isidore of Seville', file: 'saint_isidore.png' },
  'isidore of seville': { name: 'St. Isidore of Seville', file: 'saint_isidore.png' },
  'james the greater': { name: 'St. James the Greater', file: 'saint_jamesgreater.png' },
  'jamesgreater': { name: 'St. James the Greater', file: 'saint_jamesgreater.png' },
  'james the lesser': { name: 'St. James the Lesser', file: 'saint_jameslesser.png' },
  'jameslesser': { name: 'St. James the Lesser', file: 'saint_jameslesser.png' },
  'jerome': { name: 'St. Jerome', file: 'saint_jerome.png' },
  'joachim': { name: 'St. Joachim', file: 'saint_joachim.png' },
  'joan': { name: 'St. Joan of Arc', file: 'saint_joan.png' },
  'joan of arc': { name: 'St. Joan of Arc', file: 'saint_joan.png' },
  'jogues': { name: 'St. Isaac Jogues', file: 'saint_jogues.png' },
  'isaac jogues': { name: 'St. Isaac Jogues', file: 'saint_jogues.png' },
  'john of the cross': { name: 'St. John of the Cross', file: 'saint_johncross.png' },
  'johncross': { name: 'St. John of the Cross', file: 'saint_johncross.png' },
  'jose': { name: 'St. Jose Sanchez del Rio', file: 'saint_jose.png' },
  'jose sanchez': { name: 'St. Jose Sanchez del Rio', file: 'saint_jose.png' },
  'joseph': { name: 'St. Joseph', file: 'saint_joseph.png' },
  'jp2': { name: 'St. John Paul II', file: 'saint_jp2.png' },
  'john paul ii': { name: 'St. John Paul II', file: 'saint_jp2.png' },
  'john paul': { name: 'St. John Paul II', file: 'saint_jp2.png' },
  'juan': { name: 'St. Juan Diego', file: 'saint_juan.png' },
  'juan diego': { name: 'St. Juan Diego', file: 'saint_juan.png' },
  'jude': { name: 'St. Jude', file: 'saint_jude.png' },
  'kateri': { name: 'St. Kateri Tekakwitha', file: 'saint_kateri.png' },
  'kateri tekakwitha': { name: 'St. Kateri Tekakwitha', file: 'saint_kateri.png' },
  'kim': { name: 'St. Andrew Kim', file: 'saint_kim.png' },
  'andrew kim': { name: 'St. Andrew Kim', file: 'saint_kim.png' },
  'kolbe': { name: 'St. Maximilian Kolbe', file: 'saint_kolbe.png' },
  'maximilian kolbe': { name: 'St. Maximilian Kolbe', file: 'saint_kolbe.png' },
  'laboure': { name: 'St. Catherine Laboure', file: 'saint_laboure.png' },
  'catherine laboure': { name: 'St. Catherine Laboure', file: 'saint_laboure.png' },
  'lasalle': { name: 'St. John Baptist de La Salle', file: 'saint_lasalle.png' },
  'la salle': { name: 'St. John Baptist de La Salle', file: 'saint_lasalle.png' },
  'lawrence': { name: 'St. Lawrence', file: 'saint_lawrence.png' },
  'lazarus': { name: 'St. Lazarus', file: 'saint_lazarus.png' },
  'longinus': { name: 'St. Longinus', file: 'saint_longinus.png' },
  'lorenzo': { name: 'St. Lorenzo Ruiz', file: 'saint_lorenzo.png' },
  'lorenzo ruiz': { name: 'St. Lorenzo Ruiz', file: 'saint_lorenzo.png' },
  'louis': { name: 'St. Louis de Montfort', file: 'saint_louis.png' },
  'louis de montfort': { name: 'St. Louis de Montfort', file: 'saint_louis.png' },
  'louis ix': { name: 'St. Louis IX', file: 'saint_louisix.png' },
  'louisix': { name: 'St. Louis IX', file: 'saint_louisix.png' },
  'lucy': { name: 'St. Lucy', file: 'saint_lucy.png' },
  'luke': { name: 'St. Luke the Evangelist', file: 'saint_luke.png' },
  'lwanga': { name: 'St. Charles Lwanga', file: 'saint_lwanga.png' },
  'charles lwanga': { name: 'St. Charles Lwanga', file: 'saint_lwanga.png' },
  'macarius': { name: 'St. Macarius', file: 'saint_macarius.png' },
  'magdalene': { name: 'St. Mary Magdalene', file: 'saint_magdalene.png' },
  'mary magdalene': { name: 'St. Mary Magdalene', file: 'saint_magdalene.png' },
  'margaret of cortona': { name: 'St. Margaret of Cortona', file: 'saint_margaretcortona.png' },
  'margaretcortona': { name: 'St. Margaret of Cortona', file: 'saint_margaretcortona.png' },
  'margaret mary': { name: 'St. Margaret Mary Alacoque', file: 'saint_margaretmary.png' },
  'margaretmary': { name: 'St. Margaret Mary Alacoque', file: 'saint_margaretmary.png' },
  'margaret of scotland': { name: 'St. Margaret of Scotland', file: 'saint_margaretscotland.png' },
  'margaretscotland': { name: 'St. Margaret of Scotland', file: 'saint_margaretscotland.png' },
  'marina': { name: 'St. Marina', file: 'saint_marina.png' },
  'mark': { name: 'St. Mark the Evangelist', file: 'saint_mark.png' },
  'martha': { name: 'St. Martha', file: 'saint_martha.png' },
  'martin': { name: 'St. Martin de Porres', file: 'saint_martin.png' },
  'martin de porres': { name: 'St. Martin de Porres', file: 'saint_martin.png' },
  'mary of egypt': { name: 'St. Mary of Egypt', file: 'saint_maryegypt.png' },
  'maryegypt': { name: 'St. Mary of Egypt', file: 'saint_maryegypt.png' },
  'matthew': { name: 'St. Matthew', file: 'saint_matthew.png' },
  'methodius': { name: 'St. Methodius', file: 'saint_methodius.png' },
  'michael': { name: 'St. Michael the Archangel', file: 'saint_michael.png' },
  'miki': { name: 'St. Paul Miki', file: 'saint_miki.png' },
  'paul miki': { name: 'St. Paul Miki', file: 'saint_miki.png' },
  'monica': { name: 'St. Monica', file: 'saint_monica.png' },
  'more': { name: 'St. Thomas More', file: 'saint_more.png' },
  'thomas more': { name: 'St. Thomas More', file: 'saint_more.png' },
  'moses': { name: 'St. Moses the Black', file: 'saint_moses.png' },
  'moses the black': { name: 'St. Moses the Black', file: 'saint_moses.png' },
  'neumann': { name: 'St. John Neumann', file: 'saint_neumann.png' },
  'john neumann': { name: 'St. John Neumann', file: 'saint_neumann.png' },
  'newman': { name: 'St. John Henry Newman', file: 'saint_newman.png' },
  'john henry newman': { name: 'St. John Henry Newman', file: 'saint_newman.png' },
  'nicholas': { name: 'St. Nicholas', file: 'saint_nicholas.png' },
  'olaf': { name: 'St. Olaf', file: 'saint_olaf.png' },
  'olga': { name: 'St. Olga', file: 'saint_olga.png' },
  'padre pio': { name: 'St. Padre Pio', file: 'saint_padrepio.png' },
  'padrepio': { name: 'St. Padre Pio', file: 'saint_padrepio.png' },
  'pio': { name: 'St. Padre Pio', file: 'saint_padrepio.png' },
  'pancras': { name: 'St. Pancras', file: 'saint_pancras.png' },
  'patrick': { name: 'St. Patrick', file: 'saint_patrick.png' },
  'paul': { name: 'St. Paul the Apostle', file: 'saint_paul.png' },
  'paul of the cross': { name: 'St. Paul of the Cross', file: 'saint_paulcross.png' },
  'paulcross': { name: 'St. Paul of the Cross', file: 'saint_paulcross.png' },
  'paul the hermit': { name: 'St. Paul the Hermit', file: 'saint_paulhermit.png' },
  'paulhermit': { name: 'St. Paul the Hermit', file: 'saint_paulhermit.png' },
  'perpetua': { name: 'Sts. Perpetua and Felicity', file: 'saint_perpetua.png' },
  'perpetua and felicity': { name: 'Sts. Perpetua and Felicity', file: 'saint_perpetua.png' },
  'peter': { name: 'St. Peter the Apostle', file: 'saint_peter.png' },
  'philip': { name: 'St. Philip the Apostle', file: 'saint_philip.png' },
  'philip neri': { name: 'St. Philip Neri', file: 'saint_philipneri.png' },
  'philipneri': { name: 'St. Philip Neri', file: 'saint_philipneri.png' },
  'philomena': { name: 'St. Philomena', file: 'saint_philomena.png' },
  'polycarp': { name: 'St. Polycarp', file: 'saint_polycarp.png' },
  'possenti': { name: 'St. Gabriel Possenti', file: 'saint_possenti.png' },
  'gabriel possenti': { name: 'St. Gabriel Possenti', file: 'saint_possenti.png' },
  'raphael': { name: 'St. Raphael the Archangel', file: 'saint_raphael.png' },
  'rita': { name: 'St. Rita of Cascia', file: 'saint_rita.png' },
  'rita of cascia': { name: 'St. Rita of Cascia', file: 'saint_rita.png' },
  'romero': { name: 'St. Oscar Romero', file: 'saint_romero.png' },
  'oscar romero': { name: 'St. Oscar Romero', file: 'saint_romero.png' },
  'rose': { name: 'St. Rose of Lima', file: 'saint_rose.png' },
  'rose of lima': { name: 'St. Rose of Lima', file: 'saint_rose.png' },
  'scholastica': { name: 'St. Scholastica', file: 'saint_scholastica.png' },
  'sebastian': { name: 'St. Sebastian', file: 'saint_sebastian.png' },
  'serra': { name: 'St. Junipero Serra', file: 'saint_serra.png' },
  'junipero serra': { name: 'St. Junipero Serra', file: 'saint_serra.png' },
  'simon': { name: 'St. Simon', file: 'saint_simon.png' },
  'simon stock': { name: 'St. Simon Stock', file: 'saint_simonstock.png' },
  'simonstock': { name: 'St. Simon Stock', file: 'saint_simonstock.png' },
  'simon the zealot': { name: 'St. Simon the Zealot', file: 'saint_simonzealot.png' },
  'simonzealot': { name: 'St. Simon the Zealot', file: 'saint_simonzealot.png' },
  'stanislaus': { name: 'St. Stanislaus', file: 'saint_stanislaus.png' },
  'stanislaus kostka': { name: 'St. Stanislaus Kostka', file: 'saint_stanislauskostka.png' },
  'stanislauskostka': { name: 'St. Stanislaus Kostka', file: 'saint_stanislauskostka.png' },
  'stein': { name: 'St. Edith Stein', file: 'saint_stein.png' },
  'edith stein': { name: 'St. Edith Stein', file: 'saint_stein.png' },
  'stephen': { name: 'St. Stephen', file: 'saint_stephen.png' },
  'stephenhungary': { name: 'St. Stephen of Hungary', file: 'saint_stephenhungary.png' },
  'tarcisius': { name: 'St. Tarcisius', file: 'saint_tarcisius.png' },
  'teresa': { name: 'St. Teresa of Calcutta', file: 'saint_teresa.png' },
  'teresa of calcutta': { name: 'St. Teresa of Calcutta', file: 'saint_teresa.png' },
  'mother teresa': { name: 'St. Teresa of Calcutta', file: 'saint_teresa.png' },
  'teresa of avila': { name: 'St. Teresa of Avila', file: 'saint_teresaavila.png' },
  'teresaavila': { name: 'St. Teresa of Avila', file: 'saint_teresaavila.png' },
  'therese': { name: 'St. Therese of Lisieux', file: 'saint_therese.png' },
  'therese of lisieux': { name: 'St. Therese of Lisieux', file: 'saint_therese.png' },
  'little flower': { name: 'St. Therese of Lisieux', file: 'saint_therese.png' },
  'thomas': { name: 'St. Thomas the Apostle', file: 'saint_thomas.png' },
  'veronica': { name: 'St. Veronica', file: 'saint_veronica.png' },
  'vianney': { name: 'St. John Vianney', file: 'saint_vianney.png' },
  'john vianney': { name: 'St. John Vianney', file: 'saint_vianney.png' },
  'cure of ars': { name: 'St. John Vianney', file: 'saint_vianney.png' },
  'vincent': { name: 'St. Vincent de Paul', file: 'saint_vincent.png' },
  'vincent de paul': { name: 'St. Vincent de Paul', file: 'saint_vincent.png' },
  'vladimir': { name: 'St. Vladimir', file: 'saint_vladimir.png' },
  'wenceslaus': { name: 'St. Wenceslaus', file: 'saint_wenceslaus.png' },
  'zelie': { name: 'St. Zelie Martin', file: 'saint_zelie.png' },
  'zelie martin': { name: 'St. Zelie Martin', file: 'saint_zelie.png' },
  'zita': { name: 'St. Zita', file: 'saint_zita.png' },
  // Marian
  'fatima': { name: 'Our Lady of Fatima', file: 'mary_fatima.png' },
  'our lady of fatima': { name: 'Our Lady of Fatima', file: 'mary_fatima.png' },
  'grace': { name: 'Our Lady of Grace', file: 'mary_grace.png' },
  'our lady of grace': { name: 'Our Lady of Grace', file: 'mary_grace.png' },
  'guadalupe': { name: 'Our Lady of Guadalupe', file: 'mary_guadalupe.png' },
  'our lady of guadalupe': { name: 'Our Lady of Guadalupe', file: 'mary_guadalupe.png' },
  'lourdes': { name: 'Our Lady of Lourdes', file: 'mary_lourdes.png' },
  'our lady of lourdes': { name: 'Our Lady of Lourdes', file: 'mary_lourdes.png' },
  'rosary': { name: 'Our Lady of the Rosary', file: 'mary_rosary.png' },
  'our lady of the rosary': { name: 'Our Lady of the Rosary', file: 'mary_rosary.png' },
  'sorrows': { name: 'Our Lady of Sorrows', file: 'mary_sorrows.png' },
  'our lady of sorrows': { name: 'Our Lady of Sorrows', file: 'mary_sorrows.png' },
  // Special
  'redeemer': { name: 'Ultimate Redeemer', file: 'ultimate_redeemer.png' },
  'ultimate redeemer': { name: 'Ultimate Redeemer', file: 'ultimate_redeemer.png' },
};

// ── Bird Badges (52) ──

const BIRD_BADGES = [
  { week: 1, name: 'Hummingbird Herald', file: 'hummingbird.png' },
  { week: 2, name: 'Kingfisher Kickoff', file: 'kingfisher.png' },
  { week: 3, name: 'Cardinal Courage', file: 'cardinal.png' },
  { week: 4, name: 'Flamingo Focus', file: 'flamingo.png' },
  { week: 5, name: 'Toucan Triumph', file: 'toucan.png' },
  { week: 6, name: 'Peacock Pride', file: 'peacock.png' },
  { week: 7, name: 'Pelican Persistence', file: 'pelican.png' },
  { week: 8, name: 'Macaw Motivation', file: 'macaw.png' },
  { week: 9, name: 'Albatross Adventure', file: 'albatross.png' },
  { week: 10, name: 'Puffin Power', file: 'puffin.png' },
  { week: 11, name: 'Heron Habits', file: 'heron.png' },
  { week: 12, name: 'Duck Dedication', file: 'duck.png' },
  { week: 13, name: 'Bald Eagle Excellence', file: 'baldeagle.png' },
  { week: 14, name: 'Pigeon Starter', file: 'pigeon.png' },
  { week: 15, name: 'Bee-eater Brilliance', file: 'beeeater.png' },
  { week: 16, name: 'Woodpecker Wisdom', file: 'woodpecker.png' },
  { week: 17, name: 'Goose Goals', file: 'goose.png' },
  { week: 18, name: 'Quetzal Quest', file: 'quetzal.png' },
  { week: 19, name: 'Ostrich Odyssey', file: 'ostrich.png' },
  { week: 20, name: 'Bird of Paradise Performance', file: 'birdofparadise.png' },
  { week: 21, name: 'Pheasant Focus', file: 'phaesant.png' },
  { week: 22, name: 'Vulture Victory', file: 'vulture.png' },
  { week: 23, name: 'Cassowary Challenge', file: 'cassowary.png' },
  { week: 24, name: 'Raven Ratings', file: 'raven.png' },
  { week: 25, name: 'Penguin Thanksgiving', file: 'penguin.png' },
  { week: 26, name: 'Crow Marathon', file: 'crow.png' },
  { week: 27, name: 'Swan Serenity', file: 'swan.png' },
  { week: 28, name: 'Barn Owl Night Reader', file: 'barnowl.png' },
  { week: 29, name: 'Frigate Lightning', file: 'frigate.png' },
  { week: 30, name: 'Snowy Owl Scholar', file: 'snowyowl.png' },
  { week: 31, name: 'Ibis Inspiration', file: 'ibis.png' },
  { week: 32, name: 'Avocet Achievement', file: 'avocet.png' },
  { week: 33, name: 'Spoonbill Scholar', file: 'spoonbill.png' },
  { week: 34, name: 'Shoebill Strength', file: 'shoebill.png' },
  { week: 35, name: 'Oystercatcher Streak', file: 'oystercatcher.png' },
  { week: 36, name: 'Seagull Sweetheart', file: 'seagull.png' },
  { week: 37, name: 'Secretary Bird Weekend', file: 'secretarybird.png' },
  { week: 38, name: 'Turnstone Variety', file: 'turnstone.png' },
  { week: 39, name: 'Roller Progress', file: 'roller.png' },
  { week: 40, name: 'Hoopoe Luck', file: 'hoopoe.png' },
  { week: 41, name: 'Horned Owl Summit', file: 'hornedowl.png' },
  { week: 42, name: 'Lyre Bird Perfection', file: 'lyre.png' },
  { week: 43, name: 'Gannet Sprint', file: 'gannet.png' },
  { week: 44, name: 'Cormorant Democracy', file: 'cormorant.png' },
  { week: 45, name: 'Jacana Journey', file: 'jacana.png' },
  { week: 46, name: 'Booby Morning', file: 'booby.png' },
  { week: 47, name: 'Loon Library', file: 'loon.png' },
  { week: 48, name: 'Grebe Streak', file: 'grebe.png' },
  { week: 49, name: 'Sandgrouse Summer', file: 'sandgrouse.png' },
  { week: 50, name: 'Kiwi Consistency', file: 'kiwi.png' },
  { week: 51, name: 'Roadrunner Speed', file: 'roadrunner.png' },
  { week: 52, name: 'Hornbill Champion', file: 'hornbill.png' },
];

// ── Luxlings Series (16) ──

const LUXLINGS_SERIES = [
  { name: 'Apostolic Allstars', file: 'apostolic_allstars.png' },
  { name: 'Cherub Chibis', file: 'cherub_chibis.png' },
  { name: 'Contemplative Cuties', file: 'contemplative_cuties.png' },
  { name: 'Culture Carriers', file: 'culture_carriers.png' },
  { name: 'Desert Disciples', file: 'desert_disciples.png' },
  { name: 'Faithful Families', file: 'faithful_families.png' },
  { name: 'Founder Flames', file: 'founder_flames.png' },
  { name: 'Halo Hatchlings', file: 'halo_hatchlings.png' },
  { name: 'Heavenly Helpers', file: 'heavenly_helpers.png' },
  { name: 'Learning Legends', file: 'learning_legends.png' },
  { name: 'Mini Marians', file: 'mini_marians.png' },
  { name: 'Pocket Patrons', file: 'pocket_patrons.png' },
  { name: 'Regal Royals', file: 'regal_royals.png' },
  { name: 'Sacred Circle', file: 'sacred_circle.png' },
  { name: 'Super Sancti', file: 'super_sancti.png' },
  { name: 'Virtue Vignettes', file: 'virtue_vignettes.png' },
];

// ── Bookshelves (23) ──

const BOOKSHELVES = [
  { name: 'Classic Lux', file: 'classic_lux.jpg' },
  { name: 'Darkwood Sports', file: 'darkwood_sports.jpg' },
  { name: 'Lavender Space', file: 'lavender_space.jpg' },
  { name: 'Mint Music', file: 'mint_music.jpg' },
  { name: 'Pink Plushies', file: 'pink_plushies.jpg' },
  { name: 'Teal Anime', file: 'teal_anime.jpg' },
  { name: 'White Nature', file: 'white_nature.jpg' },
  { name: 'Little Luminaries', file: 'little_luminaries.jpg' },
  { name: 'St. Valentine', file: 'st_valentine.jpg', seasonal: true, months: [2] },
  { name: 'St. Patrick', file: 'st_patrick.jpg', seasonal: true, months: [3] },
  { name: 'Lenten Journey', file: 'lenten_journey.jpg', seasonal: true, months: [2, 3, 4] },
  { name: 'Easter Glory', file: 'easter_glory.jpg', seasonal: true, months: [3, 4] },
  { name: 'Marian May', file: 'marian_may.jpg', seasonal: true, months: [5] },
  { name: 'Summer Beach', file: 'summer_beach.jpg', seasonal: true, months: [6, 7] },
  { name: 'Back to School', file: 'back_to_school.jpg', seasonal: true, months: [8, 9] },
  { name: 'Autumn Harvest', file: 'autumn_harvest.jpg', seasonal: true, months: [9, 10] },
  { name: 'Spooky Halloween', file: 'spooky_halloween.jpg', seasonal: true, months: [10] },
  { name: 'All Saints', file: 'all_saints.jpg', seasonal: true, months: [11] },
  { name: 'Thanksgiving', file: 'thanksgiving.jpg', seasonal: true, months: [11] },
  { name: 'Advent Season', file: 'advent_season.jpg', seasonal: true, months: [12] },
  { name: 'St. Nicholas', file: 'st_nicholas.jpg', seasonal: true, months: [12] },
  { name: 'Winter Frost', file: 'winter_frost.jpg', seasonal: true, months: [12, 1] },
  { name: 'Epiphany Kings', file: 'epiphany_kings.jpg', seasonal: true, months: [1] },
];

// Trophy cases have the same 23 themes
const TROPHY_CASES = BOOKSHELVES.map(b => ({ ...b }));

// ── Jane Austen Battle (4) ──

const JANE_AUSTEN = [
  { name: 'Jane Austen Battle Ready', file: 'jane-austen-battle-ready.png' },
  { name: 'Jane Austen Encouraging', file: 'jane-austen-encouraging.png' },
  { name: 'Jane Austen Prayerful', file: 'jane-austen-prayerful.png' },
  { name: 'Jane Austen Victorious', file: 'jane-austen-victorious.png' },
];

// ── Reading DNA (6) ──

const READING_DNA = [
  { name: 'Challenge Seeker', file: 'challenge_seeker.png' },
  { name: 'Creative Explorer', file: 'creative_explorer.png' },
  { name: 'Curious Investigator', file: 'curious_investigator.png' },
  { name: 'Freedom Reader', file: 'freedom_reader.png' },
  { name: 'Reflective Thinker', file: 'reflective_thinker.png' },
  { name: 'Social Connector', file: 'social_connector.png' },
];

// ── Genre Covers (24) ──

const GENRE_COVERS = [
  { name: 'Adventure', file: 'adventure.jpg' },
  { name: 'Biography & Memoir', file: 'biography-memoir.jpg' },
  { name: 'Business', file: 'business.jpg' },
  { name: 'Classics', file: 'classics.jpg' },
  { name: 'Contemporary', file: 'contemporary.jpg' },
  { name: 'Cooking', file: 'cooking.jpg' },
  { name: 'Fantasy', file: 'fantasy.jpg' },
  { name: 'Fiction (General)', file: 'fiction-general.jpg' },
  { name: 'Graphic Novel', file: 'graphic-novel.jpg' },
  { name: 'Health & Wellness', file: 'health-wellness.jpg' },
  { name: 'Historical Fiction', file: 'historical-fiction.jpg' },
  { name: 'History', file: 'history.jpg' },
  { name: 'Horror', file: 'horror.jpg' },
  { name: 'Literary Fiction', file: 'literary-fiction.jpg' },
  { name: 'Mystery & Thriller', file: 'mystery-thriller.jpg' },
  { name: 'Parenting', file: 'parenting.jpg' },
  { name: 'Poetry', file: 'poetry.jpg' },
  { name: 'Religion & Spirituality', file: 'religion-spirituality.jpg' },
  { name: 'Romance', file: 'romance.jpg' },
  { name: 'Science Fiction', file: 'science-fiction.jpg' },
  { name: 'Science & Nature', file: 'science-nature.jpg' },
  { name: 'Self-Help', file: 'self-help.jpg' },
  { name: 'Short Stories', file: 'short-stories.jpg' },
  { name: 'Travel', file: 'travel.jpg' },
];

// ── Logos (3) ──

const LOGOS = [
  { name: 'Lux Libris Logo (PNG)', file: 'lux_libris_logo.png' },
  { name: 'Lux Libris Logo (JPG)', file: 'lux_libris_logo.jpg' },
  { name: 'Lux Libris Name', file: 'lux_libris_name.png' },
];

// ── Lookup Functions ──

export function findSaintImage(query) {
  if (!query) return null;
  const q = query.toLowerCase()
    .replace(/^(st\.?|saint|blessed|bl\.?)\s*/i, '')
    .replace(/^our lady of\s*/i, '')
    .trim();

  // Try exact match first
  if (SAINT_LOOKUP[q]) {
    return { name: SAINT_LOOKUP[q].name, url: `${LUX_LIBRIS_BASE_URL}/saints/${SAINT_LOOKUP[q].file}` };
  }

  // Try partial match — find longest matching key
  let bestMatch = null;
  let bestLen = 0;
  for (const [key, val] of Object.entries(SAINT_LOOKUP)) {
    if (q.includes(key) && key.length > bestLen) {
      bestMatch = val;
      bestLen = key.length;
    }
  }
  if (bestMatch) {
    return { name: bestMatch.name, url: `${LUX_LIBRIS_BASE_URL}/saints/${bestMatch.file}` };
  }

  return null;
}

export function findBirdBadge(query) {
  if (!query) return null;

  // Try week number
  const weekNum = parseInt(query, 10);
  if (!isNaN(weekNum)) {
    const badge = BIRD_BADGES.find(b => b.week === weekNum);
    if (badge) return { week: badge.week, name: badge.name, url: `${LUX_LIBRIS_BASE_URL}/badges/${badge.file}` };
  }

  // Try name match
  const q = query.toLowerCase();
  const badge = BIRD_BADGES.find(b =>
    b.name.toLowerCase().includes(q) || q.includes(b.name.toLowerCase()) ||
    q.includes(b.file.replace('.png', ''))
  );
  if (badge) return { week: badge.week, name: badge.name, url: `${LUX_LIBRIS_BASE_URL}/badges/${badge.file}` };

  return null;
}

export function findLuxlingsSeries(query) {
  if (!query) return null;
  const q = query.toLowerCase();
  const series = LUXLINGS_SERIES.find(s =>
    s.name.toLowerCase().includes(q) || q.includes(s.name.toLowerCase()) ||
    q.includes(s.file.replace('.png', '').replace(/_/g, ' '))
  );
  if (series) return { name: series.name, url: `${LUX_LIBRIS_BASE_URL}/luxlings_series/${series.file}` };
  return null;
}

export function getSeasonalTheme(date = new Date()) {
  const month = date.getMonth() + 1;
  const seasonal = BOOKSHELVES.filter(b => b.seasonal && b.months?.includes(month));
  if (seasonal.length === 0) return null;
  const theme = seasonal[0];
  return {
    name: theme.name,
    bookshelfUrl: `${LUX_LIBRIS_BASE_URL}/bookshelves/${theme.file}`,
    trophyCaseUrl: `${LUX_LIBRIS_BASE_URL}/trophy_cases/${theme.file}`,
  };
}

export function resolveAssetFromNote(imageNote) {
  if (!imageNote) return null;
  const note = imageNote.toLowerCase();

  // Check for saint references
  if (note.includes('saint') || note.includes('st.') || note.includes('our lady') ||
      note.includes('blessed') || note.includes('mary') || note.includes('card')) {
    const result = findSaintImage(imageNote);
    if (result) return { type: 'saint', ...result };
  }

  // Check for bird badge references
  if (note.includes('badge') || note.includes('bird') || note.includes('streak') || note.includes('week')) {
    const result = findBirdBadge(imageNote);
    if (result) return { type: 'badge', ...result };
  }

  // Check for luxlings references
  if (note.includes('luxling') || note.includes('series') || note.includes('collection')) {
    for (const series of LUXLINGS_SERIES) {
      if (note.includes(series.name.toLowerCase())) {
        return { type: 'luxlings', name: series.name, url: `${LUX_LIBRIS_BASE_URL}/luxlings_series/${series.file}` };
      }
    }
  }

  // Check for bookshelf/theme references
  if (note.includes('bookshelf') || note.includes('theme') || note.includes('seasonal') || note.includes('trophy')) {
    for (const shelf of BOOKSHELVES) {
      if (note.includes(shelf.name.toLowerCase())) {
        return { type: 'bookshelf', name: shelf.name, url: `${LUX_LIBRIS_BASE_URL}/bookshelves/${shelf.file}` };
      }
    }
  }

  // Check for Jane Austen references
  if (note.includes('jane austen') || note.includes('austen')) {
    for (const ja of JANE_AUSTEN) {
      const keyword = ja.name.toLowerCase().replace('jane austen ', '');
      if (note.includes(keyword)) {
        return { type: 'jane_austen', name: ja.name, url: `${LUX_LIBRIS_BASE_URL}/images/${ja.file}` };
      }
    }
    // Default to battle-ready if just "Jane Austen" mentioned
    return { type: 'jane_austen', name: JANE_AUSTEN[0].name, url: `${LUX_LIBRIS_BASE_URL}/images/${JANE_AUSTEN[0].file}` };
  }

  // Check for reading DNA references
  if (note.includes('reading dna') || note.includes('personality')) {
    for (const dna of READING_DNA) {
      if (note.includes(dna.name.toLowerCase())) {
        return { type: 'reading_dna', name: dna.name, url: `${LUX_LIBRIS_BASE_URL}/reading-dna/${dna.file}` };
      }
    }
  }

  // Check for genre cover references
  if (note.includes('genre') || note.includes('cover')) {
    for (const genre of GENRE_COVERS) {
      if (note.includes(genre.name.toLowerCase())) {
        return { type: 'genre_cover', name: genre.name, url: `${LUX_LIBRIS_BASE_URL}/book-covers/${genre.file}` };
      }
    }
  }

  // Check for logo references
  if (note.includes('logo') || note.includes('lux libris logo')) {
    return { type: 'logo', name: 'Lux Libris Logo', url: `${LUX_LIBRIS_BASE_URL}/images/lux_libris_logo.png` };
  }

  // Fallback: try saint lookup on the full note (catches "Use the Aquinas card" patterns)
  const saintFallback = findSaintImage(imageNote);
  if (saintFallback) return { type: 'saint', ...saintFallback };

  return null;
}

export function getAllAssets() {
  return {
    saints: Object.values(
      Object.entries(SAINT_LOOKUP).reduce((acc, [, val]) => {
        if (!acc[val.file]) acc[val.file] = { name: val.name, url: `${LUX_LIBRIS_BASE_URL}/saints/${val.file}` };
        return acc;
      }, {})
    ).sort((a, b) => a.name.localeCompare(b.name)),
    badges: BIRD_BADGES.map(b => ({ week: b.week, name: b.name, url: `${LUX_LIBRIS_BASE_URL}/badges/${b.file}` })),
    luxlings: LUXLINGS_SERIES.map(s => ({ name: s.name, url: `${LUX_LIBRIS_BASE_URL}/luxlings_series/${s.file}` })),
    bookshelves: BOOKSHELVES.map(b => ({ name: b.name, url: `${LUX_LIBRIS_BASE_URL}/bookshelves/${b.file}` })),
    trophyCases: TROPHY_CASES.map(t => ({ name: t.name, url: `${LUX_LIBRIS_BASE_URL}/trophy_cases/${t.file}` })),
    janeAusten: JANE_AUSTEN.map(j => ({ name: j.name, url: `${LUX_LIBRIS_BASE_URL}/images/${j.file}` })),
    readingDna: READING_DNA.map(d => ({ name: d.name, url: `${LUX_LIBRIS_BASE_URL}/reading-dna/${d.file}` })),
    genreCovers: GENRE_COVERS.map(g => ({ name: g.name, url: `${LUX_LIBRIS_BASE_URL}/book-covers/${g.file}` })),
    logos: LOGOS.map(l => ({ name: l.name, url: `${LUX_LIBRIS_BASE_URL}/images/${l.file}` })),
  };
}
